export default __webpack_public_path__ + "static/media/classify_white.e185d5fe.svg";